
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/plans",
      function () {
        return require("private-next-pages/portal/plans.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal/plans"])
      });
    }
  